import * as React from 'react';
import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import CssBaseline from '@mui/material/CssBaseline';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import List from '@mui/material/List';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import globals from '../globals';
import DashboardIcon from '@mui/icons-material/Dashboard';
import LibraryBooksIcon from '@mui/icons-material/LibraryBooks';
import VideoCameraFrontIcon from '@mui/icons-material/VideoCameraFront';
import GroupIcon from '@mui/icons-material/Group';
import SchoolIcon from '@mui/icons-material/School';
import ArticleIcon from '@mui/icons-material/Article';
import EmailIcon from '@mui/icons-material/Email';
import BeachAccessIcon from '@mui/icons-material/BeachAccess';
import AssignmentIcon from '@mui/icons-material/Assignment';
import DashboardPage from './dashboard_page';
import CoursePage from './courses_page';
import InstructorPage from './instructor_page';
import UserDashboard from './users_page';
import Email from './email';
import ZoomPage from './zoom_page';
import SummerSchoolPage from './summer_school_page';
import ExamsPage from './exams_page';
import WebinarsPage from './webinars_page';
import VideocamIcon from '@mui/icons-material/Videocam';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useNavigate  } from 'react-router-dom';

const drawerWidth = 240;

export default function AdminDashboard() {
    const [selectedItem, setSelectedItem] = React.useState('Табло');
    const navigate = useNavigate()

    const primaryItems = [
        { text: 'Табло', icon: <DashboardIcon /> },
        { text: 'Курсове', icon: <LibraryBooksIcon /> },
        { text: 'Изпити', icon: <AssignmentIcon /> },
        { text: 'Zoom срещи', icon: <VideoCameraFrontIcon /> },
        { text: 'Потребители', icon: <GroupIcon /> },
        { text: 'Учители', icon: <SchoolIcon /> },
        { text: 'Лятна занималня', icon: <BeachAccessIcon /> },
        { text: 'Уебинари', icon: <VideocamIcon /> },
    ];

    const secondaryItems = [
        { text: 'Блог', icon: <ArticleIcon /> },
        { text: 'Имейл', icon: <EmailIcon /> },
        {text: 'Назад', icon: <ArrowBackIcon />}
    ];

    function renderContent() {
        switch (selectedItem) {
            case 'Табло':
                return (
                    <DashboardPage />
                );
            case 'Курсове':
                return (
                    <CoursePage />
                );
            case 'Изпити':
                return (
                    <ExamsPage />
                );
            case 'Zoom срещи':
                return (
                    <Typography sx={{ marginBottom: 2 }}>
                    <ZoomPage />
                    </Typography>
                );
            case 'Потребители':
                return (
                    <Typography sx={{ marginBottom: 2 }}>
                        <UserDashboard />
                    </Typography>
                );
            case 'Учители':
                return (
                    <Typography sx={{ marginBottom: 2 }}>
                        <InstructorPage />
                    </Typography>
                );
            case 'Лятна занималня':
                return (
                    <Typography sx={{ marginBottom: 2 }}>
                        <SummerSchoolPage />
                    </Typography>
                );
            case 'Уебинари':
                return (
                    <Typography sx={{ marginBottom: 2 }}>
                        <WebinarsPage />
                    </Typography>
                );
            case 'Блог':
                return (
                    <Typography sx={{ marginBottom: 2 }}>
                        Създавайте и редактирайте блог публикации и категории.
                    </Typography>
                );
            case 'Имейл':
                return (
                    <Typography sx={{ marginBottom: 2 }}>
                        <Email />
                    </Typography>
                );
            case 'Назад': 
                navigate('/')
                return null;
            default:
                return null;
        }
    }
    return (
        <Box sx={{ display: 'flex' }}>
            <CssBaseline />
            <AppBar
                position="fixed"
                sx={{ width: `calc(100% - ${drawerWidth}px)`, ml: `${drawerWidth}px`, backgroundColor: globals.colors.darkBlue }}
            >
                <Toolbar>
                    <Typography variant="h6" noWrap component="div">
                        Admin
                    </Typography>
                </Toolbar>
            </AppBar>
            <Drawer
                sx={{
                    width: drawerWidth,
                    flexShrink: 0,
                    '& .MuiDrawer-paper': {
                        width: drawerWidth,
                        boxSizing: 'border-box',
                    },
                }}
                variant="permanent"
                anchor="left"
            >
                <Toolbar />
                <Divider />
                <List>
                    {primaryItems.map(({ text, icon }) => (
                        <ListItem key={text} disablePadding>
                            <ListItemButton selected={selectedItem === text} onClick={() => setSelectedItem(text)}>
                                <ListItemIcon>
                                    {icon}
                                </ListItemIcon>
                                <ListItemText primary={text} />
                            </ListItemButton>
                        </ListItem>
                    ))}
                </List>
                <Divider />
                <List>
                    {secondaryItems.map(({ text, icon }) => (
                        <ListItem key={text} disablePadding>
                            <ListItemButton selected={selectedItem === text} onClick={() => setSelectedItem(text)}>
                                <ListItemIcon>
                                    {icon}
                                </ListItemIcon>
                                <ListItemText primary={text} />
                            </ListItemButton>
                        </ListItem>
                    ))}
                </List>
            </Drawer>
            <Box
                component="main"
                sx={{ flexGrow: 1, bgcolor: 'background.default', p: 3 }}
            >
                <Toolbar />
                {renderContent()}
            </Box>
        </Box>
    );
}
